import type { ThemeV3 } from '../types/themeTypes';

/** A deep midnight blue with a periwinkle accent. */
export const moonTheme = {
  id: 'Moon',
  name: 'Moon',
  version: 3,
  mode: 'dark',
  colorTokens: {
    'surface-0': 'oklch(0.15 0.012 255deg)',
    'surface-1': 'oklch(0.19 0.012 255deg)',
    'surface-2': 'oklch(0.23 0.014 255deg)',
    'surface-3': 'oklch(0.26 0.014 255deg)',
    'surface-4': 'oklch(0.3 0.016 255deg)',
    'content-0': 'oklch(0.95 0.01 255deg)',
    'content-1': 'oklch(0.85 0.01 255deg)',
    'content-2': 'oklch(0.75 0.01 255deg)',
    'content-3': 'oklch(0.65 0.01 255deg)',
    'content-4': 'oklch(0.57 0.01 255deg)',
    edge: 'oklch(0.3 0.016 255deg)',
    'edge-muted': 'oklch(0.26 0.014 255deg)',
    accent: 'oklch(0.7 0.15 255deg)',
    red: 'oklch(0.7 0.15 25.331deg)',
    orange: 'oklch(0.7 0.15 47.604deg)',
    amber: 'oklch(0.7 0.15 70.08deg)',
    yellow: 'oklch(0.7 0.15 86.047deg)',
    lime: 'oklch(0.7 0.15 130.85deg)',
    green: 'oklch(0.7 0.15 149.579deg)',
    teal: 'oklch(0.7 0.15 182.503deg)',
    cyan: 'oklch(0.7 0.15 215.221deg)',
    blue: 'oklch(0.7 0.15 259.815deg)',
    violet: 'oklch(0.7 0.15 292.717deg)',
    purple: 'oklch(0.7 0.15 303.9deg)',
    pink: 'oklch(0.7 0.15 354.308deg)',
    surface: 'var(--layer-surface)',
    inset: 'var(--layer-inset)',
    ink: 'var(--color-content-0)',
    'ink-muted': 'var(--color-content-1)',
    'ink-subtle': 'var(--color-content-2)',
    'ink-disabled': 'var(--color-content-3)',
    'ink-placeholder': 'var(--color-content-4)',
    link: 'var(--color-accent)',
    'link-hover': 'var(--color-accent)',
    'link-visited': 'var(--color-accent)',
    page: 'var(--color-surface-0)',
    panel: 'var(--color-surface-1)',
    dialog: 'var(--color-surface-2)',
    menu: 'var(--color-surface-2)',
    tooltip: 'var(--color-surface-2)',
    toast: 'var(--color-surface-2)',
    input: 'transparent',
    'input-focus': 'var(--color-surface-1)',
    message: 'var(--color-surface-1)',
    hover: 'color-mix(in oklch, var(--color-content-0) 3%, transparent)',
    active: 'color-mix(in oklch, var(--color-content-0) 6%, transparent)',
    selected: 'color-mix(in oklch, var(--color-accent) 8%, transparent)',
    success: 'var(--color-green)',
    warning: 'var(--color-amber)',
    failure: 'var(--color-red)',
    chrome:
      'color-mix(in oklch, var(--color-surface-0) 80%, var(--color-content-0))',
  },
} satisfies ThemeV3;
